import moment from "moment";

const removeCommasAndLineBreaks = (data) => {
  let obj = data;
  const isObjString = typeof obj === "string";
  if (!isObjString) obj = JSON.stringify(obj);
  obj = obj.replace(/(?=,(?!"))(,(?!{))/g, ""); // Removes commas
  obj = obj.replace(/[\t\r\n]/gm, ""); //Removes tab spaces and line breaks
  if (!isObjString) obj = JSON.parse(obj);
  return obj;
};

const exportAsCsv = (rows, columns, fileName) => {
  const columnHeaders = columns.map(
    (column) => column?.headerName || column?.header
  );

  const rowData = rows.map((row) => {
    return columns.map((column) => {
      let cellValue = removeCommasAndLineBreaks(row[column.field]);
      if (typeof cellValue === "number" || /^\d+$/.test(cellValue)) {
        cellValue = `="${cellValue}"`; // To Keep the Leading Zeros in the Excel
      } else {
        cellValue = `"${cellValue}"`;
      }

      return cellValue;
    });
  });

  const csvData = [columnHeaders.join(",")].concat(
    rowData.map((row) => row.join(","))
  );

  const csvBlob = new Blob([csvData.join("\n")], { type: "text/csv" });
  const csvUrl = URL.createObjectURL(csvBlob);

  let currentDate = new Date();
  const date = moment(new Date(currentDate)).format("YYYY-MM-DDThh:mm:ss");

  const a = document.createElement("a");
  a.href = csvUrl;
  a.download = `${fileName}_${date}.csv`;
  a.click();

  URL.revokeObjectURL(csvUrl);
};

export default exportAsCsv;
